// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");
var BrowserComponents_Icon = require("./BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("./BrowserComponents_Text.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");

function container(theme) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.alignItems(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.border(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
                      TAG: /* Grey */2,
                      _0: /* Medium */2
                    }),
                tl: {
                  hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.25)),
                  tl: {
                    hd: BrowserStyle.color(theme ? ({
                              TAG: /* White */7,
                              _0: /* Light */2
                            }) : ({
                              TAG: /* Grey */2,
                              _0: /* Dark */1
                            })),
                    tl: {
                      hd: BrowserStyle.padding2(BrowserStyle.zero, BrowserStyle.Spacing.xSmall),
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

var icon = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(0.5)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(0.5)),
        tl: /* [] */0
      }
    });

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Small */2, /* Semibold */1);
}

var text = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), /* [] */0));

var Styles = {
  container: container,
  icon: icon,
  text: text
};

function BrowserComponents_ShiftTipsIndicator(Props) {
  var className = Props.className;
  var theme = Props.theme;
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: BrowserStyle.Utils.extendBaseStyle(container(theme), className),
              children: null
            }, React.createElement(BrowserComponents_Icon.make, {
                  className: icon,
                  color: theme ? ({
                        TAG: /* White */7,
                        _0: /* Light */2
                      }) : ({
                        TAG: /* Grey */2,
                        _0: /* Dark */1
                      }),
                  icon: {
                    TAG: /* Small */1,
                    _0: {
                      TAG: /* Navigation */5,
                      _0: /* Plus */7
                    }
                  }
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XSmall */2
                }), React.createElement(BrowserComponents_Text.make, {
                  className: text,
                  children: "tips"
                }));
}

var make = BrowserComponents_ShiftTipsIndicator;

exports.Styles = Styles;
exports.make = make;
/* icon Not a pure module */
